export default __webpack_public_path__ + "static/media/contact.e16b6540.svg";